import * as types from './types'
export const mutations = {
  [types.SHOPPING_LIST_NUM](state, payload) {
    state.list = payload.list
  },
  [types.ADDRESS_INFO] (state, payload) {
    state.addressInfo = payload.addressInfo
  },
  [types.TAKER_INFO] (state, payload) {
    state.takerInfo = payload.takerInfo
  },
  [types.ORDER_CUOPON] (state, payload) {
    state.orderCoupon = {...state.orderCoupon, ...payload}
  },
  [types.INVOICE_TITLE] (state, payload) {
    state.invoiceTitle = {...state.invoiceTitle, ...payload}
  }
}



// WEBPACK FOOTER //
// ./src/stores/mall/mutations.js